export default __webpack_public_path__ + "static/media/icon-reparo.55039430.svg";